// removed by extract-text-webpack-plugin
module.exports = {"container_0":"container_0___IXJ-U","container_1":"container_1___170TK","container_2":"container_2___NjvSh"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Brand/styles.module.scss
// module id = 727
// module chunks = 0